import TextEffectsSharedPreviewMapper from '../../TextEffectsShared/viewer/TextEffectsShared.previewMapper';

export default TextEffectsSharedPreviewMapper;
